import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Router, RouterLink, RouterLinkActive, RouterOutlet} from '@angular/router';
import {MatSidenav, MatSidenavContainer, MatSidenavContent} from '@angular/material/sidenav';
import {MatToolbar} from '@angular/material/toolbar';
import {MatButton, MatFabButton, MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {MatBadge} from '@angular/material/badge';
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';
import {MatTooltip} from '@angular/material/tooltip';
import {MenuItem} from '../../models/MenuItem';
import {MatListItem, MatNavList} from '@angular/material/list';
import {BehaviorSubject, interval, of, startWith, Subscription} from 'rxjs';
import {AuthService} from '../../services/auth.service';
import {StoreManagerService} from '../../services/store-manager.service';
import {FooterComponent} from '../footer/footer.component';
import {TokenService} from '../../services/token.service';
import {AsyncPipe, DatePipe} from '@angular/common';
import {InAppNotificationService} from '../../services/in-app-notification.service';
import {InAppNotification} from '../../services/models/InAppNotification';

@Component({
  selector: 'antm-menu',
  imports: [
    RouterOutlet,
    MatSidenavContainer,
    MatSidenav,
    MatSidenavContent,
    MatToolbar,
    MatIconButton,
    MatIcon,
    MatButton,
    MatNavList,
    MatListItem,
    RouterLinkActive,
    RouterLink,
    FooterComponent,
    AsyncPipe,
    DatePipe,
    MatFabButton,
    MatBadge,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    MatTooltip
  ],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss',
})
export class MenuComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('toolbar', {read: ElementRef}) toolbar!: ElementRef;
  @ViewChild('footer', {read: ElementRef}) footer!: ElementRef;
  @ViewChild('contentWrapper', {read: ElementRef}) contentWrapper!: ElementRef;
  // ✅ Hauteurs dynamiques
  toolbarHeight = 64;
  footerHeight = 72;
  contentHeight = 0;
  collapsed: boolean = false;
  width = window.innerWidth;

  private currentThemeSubject = new BehaviorSubject<string>('light');
  private resizeObserver?: ResizeObserver;

  notifications: InAppNotification[] = [];
  private notificationSubscriptions = new Subscription();

  constructor(
    private cdr: ChangeDetectorRef,
    private _authService: AuthService,
    private tokenService: TokenService,
    private _storeManager: StoreManagerService,
    private _inAppNotificationService: InAppNotificationService,
    private _router: Router
  ) {
  }

  menuItems: MenuItem[] = []

  ngOnInit(): void {
    if (this.width < 640) {
      this.collapsed = true;
    }
    this.initNotifications();
    this._storeManager.initializeAllStores()
    this.menuItems = [
      {
        icon: 'dashboard',
        label: 'Vendre des tickets',
        route: 'sell',
        available: of(this.tokenService.hasRole('MANAGER') && (this.tokenService.isFinexs() || this.tokenService.isSaramaya() ))
      },
      {
        icon: 'payment',
        label: 'Paiements',
        route: 'payments',
        available: of(this.tokenService.hasRole('MANAGER'))
      },

      {
        icon: 'dashboard',
        label: 'Envoyer un colis',
        route: 'sell-parcel',
        available: of(this.tokenService.hasAnyRole('MANAGER', 'SUPERVISOR'))
      },
      {
        icon: 'format_list_bulleted',
        label: 'Type de colis',
        route: 'parcel-types',
        available: of(this.tokenService.hasRole('MANAGER') && this.tokenService.isFinexs())
      },
      {
        icon: 'format_list_bulleted',
        label: 'Lignes',
        route: 'traject-lines',
        available: of(this.tokenService.hasRole('MANAGER') && this.tokenService.isFinexs())
      },
      {
        icon: 'train',
        label: 'Gares',
        route: 'bus-stations',
        available: of(this.tokenService.hasRole('MANAGER'))
      },
      {
        icon: 'notifications',
        label: 'Notifications',
        route: 'notifications',
        available: of(this.tokenService.hasRole('MANAGER') && this.tokenService.isSaramaya())
      },



      // {
      //   icon: 'edit_note',
      //   label: 'Administration',
      //   route: 'forms',
      // },
      {
        icon: 'folder',
        label: 'Documents',
        route: 'documents',
        available: of(this.tokenService.hasRole('MANAGER'))
      },
      // {
      //   icon: 'video_library',
      //   label: 'Moyens de paiement',
      //   route: 'content',
      // },
      // {
      //   icon: 'video_library',
      //   label: 'Mes statistiques',
      //   route: 'stats',
      // },
      // {
      //   icon: 'video_library',
      //   label: 'Catégories',
      //   route: 'content',
      // },
      // {
      //   icon: 'video_library',
      //   label: 'Contrôleurs',
      //   route: 'content',
      // },
      {
        icon: 'group',
        label: 'Passagers',
        route: 'passengers',
        available: of(this.tokenService.hasAnyRole('MANAGER', 'SUPERVISOR'))
      },
      {
        icon: 'directions_bus',
        label: 'Bus',
        route: 'buses',
        available: of(this.tokenService.hasAnyRole('MANAGER', 'SUPERVISOR'))
      },

      {
        icon: 'inventory_2',
        label: 'Colis',
        route: 'parcels',
        available: of(this.tokenService.hasAnyRole('MANAGER', 'SUPERVISOR'))
      },

      {
        icon: 'inventory_2',
        label: 'Appels Externes',
        route: 'external-calls',
        available: of(this.tokenService.hasAnyRole('MANAGER', 'SUPERVISOR'))
      },


      // {
      //   icon: 'video_library',
      //   label: 'Paiements',
      //   route: 'content',
      // },
      // {
      //   icon: 'video_library',
      //   label: 'Gares',
      //   route: 'content',
      // },
      // {
      //   icon: 'video_library',
      //   label: 'Notifications',
      //   route: 'content',
      // },
      // {
      //   icon: 'video_library',
      //   label: 'Trajets',
      //   route: 'content',
      // },
      // {
      //   icon: 'video_library',
      //   label: 'Lignes',
      //   route: 'content',
      // },
      // {
      //   icon: 'video_library',
      //   label: 'Départs',
      //   route: 'content',
      // },
      {
        icon: 'analytics',
        label: 'Statistiques',
        route: 'stats',
        available: of(this.tokenService.hasRole('MANAGER') && this.tokenService.isFinexs())
      },
      {
        icon: 'directions_bus',
        label: 'Modèle de bus',
        route: 'bus-models',
        available: of(this.tokenService.hasRole('MANAGER') && this.tokenService.isFinexs())
      },
      {
        icon: 'route',
        label: 'Trajets',
        route: 'trajects',
        available: of(this.tokenService.hasRole('MANAGER'))
      },
      {
        icon: 'departure_board',
        label: 'Départs',
        route: 'departures',
        available: of(this.tokenService.hasRole('MANAGER'))
      },
      {
        icon: 'confirmation_number',
        label: this.tokenService.isFinexs() ? 'Réservations' : 'Tickets',
        route: 'sales',
        available: of(this.tokenService.hasAnyRole('MANAGER', 'SUPERVISOR'))
      },
      {
        icon: 'group',
        label: 'Employés',
        route: 'employees',
        available: of(this.tokenService.hasAnyRole('MANAGER'))
      },
      {
        icon: 'account_balance',
        label: 'Royalties',
        route: 'royalties',
        available: of(this.tokenService.hasRole('ADMIN'))
      },

    ];
    this.menuItems.sort((a, b) => a.label.localeCompare(b.label));
    this.setTheme(this.tokenService.getCompanyId());
  }

  ngAfterViewInit(): void {
    // Calculer les hauteurs initiales
    this.updateHeights();

    // Observer les changements de taille
    this.setupResizeObserver();

    // Écouter le redimensionnement de la fenêtre
    window.addEventListener('resize', () => this.updateHeights());
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    window.removeEventListener('resize', () => this.updateHeights());
    this.notificationSubscriptions.unsubscribe();
  }

  get canSeeNotifications(): boolean {
    return this.tokenService.hasAnyRole('ADMIN', 'MANAGER', 'SUPERVISOR');
  }

  private initNotifications(): void {
    if (!this.canSeeNotifications) {
      return;
    }
    this.notificationSubscriptions.add(
      this._inAppNotificationService.notifications$.subscribe(notifications => this.notifications = notifications)
    );
    this.notificationSubscriptions.add(
      interval(30_000).pipe(startWith(0)).subscribe(() => this._inAppNotificationService.refresh())
    );
  }

  openNotification(notification: InAppNotification): void {
    if (notification.type === 'CONVERSION_COMPLETED') {
      this._inAppNotificationService.markAsRead(notification.id)
        .subscribe(() => this._inAppNotificationService.refresh());
    }
    if (notification.type === 'CONVERSION_REQUESTED' || notification.type === 'CONVERSION_COMPLETED') {
      this._router.navigate(['/sales', notification.reference, 'details']);
    }
  }

  private updateHeights() {
    setTimeout(() => {
      // ✅ Récupérer les hauteurs réelles
      if (this.toolbar) {
        this.toolbarHeight = this.toolbar.nativeElement.offsetHeight;
      }

      if (this.footer) {
        this.footerHeight = this.footer.nativeElement.offsetHeight;
      }

      // ✅ Calculer la hauteur disponible pour le contenu
      this.contentHeight = window.innerHeight - this.toolbarHeight - this.footerHeight;

      // Appliquer la hauteur au wrapper de contenu
      if (this.contentWrapper) {
        this.contentWrapper.nativeElement.style.height = `${this.contentHeight}px`;
      }

      console.log('📐 Hauteurs calculées:');
      console.log('  Viewport:', window.innerHeight);
      console.log('  Toolbar:', this.toolbarHeight);
      console.log('  Footer:', this.footerHeight);
      console.log('  Contenu:', this.contentHeight);

      // Forcer la détection des changements
      this.cdr.detectChanges();
    }, 0);
  }

  private setupResizeObserver() {
    this.resizeObserver = new ResizeObserver(() => {
      this.updateHeights();
    });

    // ✅ Observer la toolbar
    if (this.toolbar) {
      this.resizeObserver.observe(this.toolbar.nativeElement);
    }

    // ✅ Observer le footer
    if (this.footer) {
      this.resizeObserver.observe(this.footer.nativeElement);
    }
  }

  logout() {
    // this.oauthService.logOut();
    sessionStorage.clear();
    localStorage.clear();
    this._storeManager.clearAllStores();
    this._authService.logout();
    // sessionStorage.clear();
    // localStorage.clear();
    // this._oauthService.revokeTokenAndLogout();
  }

  setTheme(theme: string): void {
    const validTheme = theme;
    this.currentThemeSubject.next(validTheme);
    document.documentElement.setAttribute('data-theme', validTheme);
  }

  switchedCollapsed(): void {
    this.collapsed = !this.collapsed
  }

  getLogoName(): string {
    if (this.tokenService.isFinexs()) {
      return 'assets/images/logo-finexs.png';
    } else if (this.tokenService.isRahimo()) {
      return 'assets/images/logo-rahimo.png';
    } else if (this.tokenService.isSaramaya()) {
      return 'assets/images/logo-saramaya.jpg';
    }
    return 'assets/images/logo_unnamed.png';
  }
}
